import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

export function ShowSpinnerOrLabel({ loading, label, variant, size = 25, thickness = 2 }) {
    return <React.Fragment>
        {
            !loading ?
                label :
                <CircularProgress sx={{ color: variant }} size={size} thickness={thickness} />
        }
    </React.Fragment>
}